import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

import headerImagePng from "../assets/images/ronlogo.png"
import footerImagePng from "../assets/images/power-rysun-logo.png"
import { getFileName } from './helper';


export interface userPreferencesType{
    
    Forecast_by: string | undefined,
    Start_date: string | undefined,
    End_date: string | undefined,


}


export const generateExcel = async (userPreferences: userPreferencesType , excelData : any[] | undefined, excelHeaders: string[]) => {
    console.log(excelData)
    // Create a new workbook and add a worksheet
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Summary');

    // Convert image to base64
    const headerImageBase64 = await fetchImageAsBase64(headerImagePng);

    // Add image to the workbook
    const headerImageId = workbook.addImage({
        base64: headerImageBase64,
        extension: 'png',
    });

    const footerImageBase64 = await fetchImageAsBase64(footerImagePng);

    // Add image to the workbook
    const footerImageId = workbook.addImage({
        base64: footerImageBase64,
        extension: 'png',
    });

    worksheet.mergeCells('A1:E5');

    // Add the image to span from cell A1 to E3
    worksheet.addImage(headerImageId, {
        tl: { col: 0, row: 2 }, // Top-left position of the image in cell E1
        ext: { width: 104, height: 26 }, // Adjust width and height to fit the desired span
        editAs: 'absolute', // Ensures the image position is set explicitly
    });

    

//forecast title
    worksheet.getCell('A6').value = 'Sales Forecast';
    worksheet.getCell('A6').font = { name: 'Arial', size: 16, bold: false };
    worksheet.getCell('A6').alignment = { vertical: 'middle', horizontal: 'center' };

    worksheet.mergeCells('A6:E7');

    // Adjust column widths for better visibility


    worksheet.getRow(6).height = 25;

    const tableHeaders = Object.keys(userPreferences).map(header =>
        header.replace(/_/g, ' ')
    );
    const data = [Object.values(userPreferences)];

    // Add table headers to row 8
    worksheet.addRow(tableHeaders).font = { bold: false, size: 10 };

    // Add table data starting from row 9
    worksheet.addRow(data[0]);

    // Apply formatting to the table headers
    worksheet.getRow(8).eachCell({ includeEmpty: true }, (cell) => {
        cell.alignment = { horizontal: 'center' };
        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'D9D9D9' }, // Yellow background
        };
        cell.border = {
            bottom: { style: 'thin' },
        };
    });

    // Apply formatting to table data
    worksheet.getRow(9).eachCell({ includeEmpty: true }, (cell) => {
        cell.alignment = { horizontal: 'center' };
        cell.border = {
            bottom: { style: 'thin' },
        };
    });



    ////////////////////////////


    worksheet.addRow(excelHeaders.filter(key => key !== "history" && key !== "forecast")).font = { bold: false, size: 10 };

    worksheet.columns = [
        { width: 10 }, // A
        { width: 10 }, // B
        { width: 10 }, // C
        { width: 10 }, // D
        { width: 20 }, // E 
        { width: 20 }, // F
        { width: 20 }, // G
        { width: 20 }, // H
    ];


    const salesInventoryDynamicTitle = excelHeaders.filter(key => key !== "history" && key !== "forecast")[1]

    excelData?.forEach((entry) => {
        worksheet.addRow([
            entry.city,
            entry.sales_manager,
            entry.sales_associate,
            entry.sales_history,
            
            entry.total_sales_forecast,
        ]).font = { bold: false, size: 10 };;
    });

    // Apply formatting to the table headers
    worksheet.getRow(10).eachCell({ includeEmpty: true }, (cell) => {
        cell.alignment = { horizontal: 'center' };
        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'D9D9D9' },
        };
        cell.border = {
            bottom: { style: 'thin' },
        };
    });


    // Adjust column widths based on content
    worksheet.columns.forEach((column) => {
        const maxLength = column.values?.reduce((max: number, value: ExcelJS.CellValue) => {
            if (typeof value === 'string') {
                return Math.max(max, value?.length);
            } else if (typeof value === 'number') {
                return Math.max(max, value.toString().length);
            } else {
                // Handle other value types as needed
                return max;
            }
        }, 0) ?? 10;

        column.width = maxLength < 10 ? 10 : maxLength;
    });


    const lastDataRow = worksheet.lastRow && worksheet.lastRow.number > 24 ? worksheet.lastRow?.number: 24;

    // Add the footer image after the last row of the data table
    worksheet.addImage(footerImageId, {
        tl: { col: 0, row: lastDataRow + 2 }, // Adjust row and column as needed
        ext: { width: 142, height: 20 }, // Set the width and height for the footer image
        editAs: 'absolute', // Ensure the image is positioned explicitly
    });
    
    // Merge cells for the footer image area if needed
    worksheet.mergeCells(`A${lastDataRow + 2}:B${lastDataRow + 3}`);


    // sheets start here

    const startSheet = 2;

    excelData?.forEach((item) => {
        const { history, forecast } = item;

        // Create a new worksheet for each item
        const worksheet_associate_name = item.hasOwnProperty("sales_associate") ? item.sales_associate : item.sales_manager
        const other_worksheet = workbook.addWorksheet(`${worksheet_associate_name}`);


        other_worksheet.mergeCells('A1:E5');

        // Add the image to span from cell A1 to E3
        other_worksheet.addImage(headerImageId, {
            tl: { col: 0, row: 2 }, // Top-left position of the image in cell E1
            ext: { width: 104, height: 26 }, // Adjust width and height to fit the desired span
            editAs: 'absolute', // Ensures the image position is set explicitly
        });
   

        // Define headers for the tables with a space between History and Forecast columns
        const tableHeader = ['History Date', 'Sales History Amt.', '', 'Forecast Date', 'Sales Forecast Amt.'];

        // Add the combined header row
        other_worksheet.addRow(tableHeader).font = { bold: true, size: 10 };

        other_worksheet.columns = [
            { width: 25 }, // A
            { width: 15 }, // B
            { width: 15 }, // C
            { width: 25 }, // D
            { width: 15 }, // E

        ];
        

        // Convert history and forecast objects into arrays of entries (key-value pairs)
        const historyEntries = Object.entries(history);
        const forecastEntries = Object.entries(forecast);

        // Determine the maximum number of rows needed
        const maxRows = Math.max(historyEntries.length, forecastEntries.length);

        // Iterate and add rows side by side with one column space
        for (let i = 0; i < maxRows; i++) {
            const historyRow = historyEntries[i] || [];
            const forecastRow = forecastEntries[i] || [];

            const [historyDate, historyPrice] = historyRow;
            const [forecastDate, forecastPrice] = forecastRow;

            other_worksheet.addRow([
                historyDate || '',   // History Date
                historyPrice|| '', // History Quantity
                '',                  // Empty column for spacing
                forecastDate || '',  // Forecast Date
                forecastPrice || '', // Forecast Quantity
            ]);
        }


        const lastDataRow = other_worksheet.lastRow?.number || 9;

        // Add the footer image after the last row of the data table
        other_worksheet.addImage(footerImageId, {
            tl: { col: 0, row: lastDataRow + 2 }, // Adjust row and column as needed
            ext: { width: 142, height: 20 }, // Set the width and height for the footer image
            editAs: 'absolute', // Ensure the image is positioned explicitly
        });
        
        // Merge cells for the footer image area if needed
        other_worksheet.mergeCells(`A${lastDataRow + 2}:B${lastDataRow + 3}`);
    });



    // Generate the Excel file
    const buffer = await workbook.xlsx.writeBuffer();

    // Generate a filename with the timestamp
    const filename = `${getFileName()}.xlsx`;
    saveAs(new Blob([buffer]), filename);
};

// Function to fetch image as base64
const fetchImageAsBase64 = async (imagePath: string): Promise<string> => {
    const response = await fetch(imagePath);
    const blob = await response.blob();
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => {
            const base64data = reader.result?.toString().split(',')[1]; // Extract base64 data without data URL prefix
            resolve(base64data || '');
        };
        reader.readAsDataURL(blob);
    });
};